// base rc-tooltip 5.1.1
import Tooltip from './src/Tooltip';
export default Tooltip;
